var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOphalerIsaetningsplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.517,9.283a.844.844,0,0,0,1.294,0,1.821,1.821,0,0,1,2.606,0,.841.841,0,0,0,1.291,0,1.82,1.82,0,0,1,2.605,0,.915.915,0,0,0,.537.291.174.174,0,0,0,.116-.157V6.75a.186.186,0,0,0-.186-.186H11.121c-.172,0-4.475,1.9-5.859,2.514C5.357,9.148,5.443,9.218,5.517,9.283Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.957,10.251a.966.966,0,0,1-.727-.332,1.7,1.7,0,0,0-2.44,0,.963.963,0,0,1-1.456,0,1.7,1.7,0,0,0-2.441,0,.965.965,0,0,1-1.458,0,1.7,1.7,0,0,0-2.445,0,.975.975,0,0,1-.73.333.375.375,0,1,0,0,.75,1.7,1.7,0,0,0,1.222-.517.967.967,0,0,1,1.46,0,1.7,1.7,0,0,0,2.444,0,.961.961,0,0,1,1.455,0,1.7,1.7,0,0,0,2.442,0,.96.96,0,0,1,1.454,0,1.693,1.693,0,0,0,1.22.517.375.375,0,0,0,0-.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27,9.628l.207-.006,8.014-3.5a1.385,1.385,0,0,0,.2-.192.123.123,0,0,0,.023-.04,1.387,1.387,0,0,0-.033-1.04A1.373,1.373,0,0,0,9.5,4.018a.13.13,0,0,0-.137.148.946.946,0,0,1-.547,1L2.879,7.756a.945.945,0,0,1-1.1-.276.132.132,0,0,0-.2,0,1.4,1.4,0,0,0,.38,2.078A.529.529,0,0,0,2.27,9.628Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOphalerIsaetningsplads);
export default __webpack_public_path__ + "static/media/OPHALER-ISAETNINGSPLADS.b22500a714767a7e9e27bf48cb252fd8.svg";
export { ForwardRef as ReactComponent };